<template>
  <div id="base_map"></div>
</template>

<script setup>
  import { ref, onMounted, toRefs, defineExpose, defineEmits } from 'vue'
  const { mapURL } = require('@/config')
  const map = ref()
  const emit = defineEmits()
  const L = window.L
  //大亚湾地图边界纬经度
  const BOUNDS = L.latLngBounds(
    L.latLng(22.378269, 113.890426),
    L.latLng(23.935243, 115.359078)
  )
  let center = ['22.754976', '114.594402'] //大亚湾中心纬经度
  onMounted(() => {
    L.Icon.Default.prototype.options.imagePath = '/static/leaflet/images/'
    map.value = L.map('base_map', {
      //地图容器
      center: center, //中心点的纬、经度
      zoomSnap: 0.5, // 允许 0.5 级别的缩放
      zoomDelta: 0.5, // 使用 0.5 的增量缩放
      zoom: 13.4,
      minZoom: 11,
      maxZoom: 17, // 最大的聚焦值
      pmIgnore: false, //使用工具栏必须配置
      noWrap: true, //解决背景图片重复的问题
      attributionControl: false, // 移除右下角标记
      zoomControl: false, //不要左上角加减号
      maxBounds: BOUNDS, //设置地图边界
      fitBounds: BOUNDS,
      setMaxBounds: BOUNDS,
      maxBoundsViscosity: 1, //到边界时不可拖动、不回弹
    })

    //挂载瓦片地图
    L.tileLayer(mapURL, {
      maxZoom: 17,
    }).addTo(map.value)
  })
  onMounted(() => {
    emit('mounted', map.value, L)
  })

  function flyTo(lng, lat) {
    map.value.flyTo(L.latLng(lat, lng))
  }

  defineExpose({
    map,
    flyTo,
  })
</script>

<style lang="less" scoped>
  #base_map {
    width: 100%;
    height: 100%;
    min-height: 100px;
    min-width: 100px;
  }
</style>
